import { useEffect } from 'react';

interface UseCloseDialogArgs {
  onClose: () => void;
}

/**
 * Hook which calls a close function when user types `ESC`
 * @param {function} onClose close function
 */
const useCloseOnEsc = ({ onClose }: UseCloseDialogArgs) => {
  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onClose]);
};

export default useCloseOnEsc;
